export default __webpack_public_path__ + "static/media/7UM511.fa353796.jpg";